import type { ErrorMap } from '@/app/error-registry';

export const WORK_SCHEDULE_TENANT_ERROR_MAP: ErrorMap = {
  PUT: {
    'WorkSchedule.InvalidHours': 'workSchedules:apiErrors.invalidHours',
    'WorkSchedule.InvalidDays': 'workSchedules:apiErrors.invalidDays',
    default: 'workSchedules:apiErrors.tenantSaveDefault',
  },
};

export const MEMBER_WORK_SCHEDULE_ERROR_MAP: ErrorMap = {
  PUT: {
    'WorkSchedule.MemberNotFound': 'workSchedules:apiErrors.memberNotFound',
    'WorkSchedule.InvalidHours': 'workSchedules:apiErrors.invalidHours',
    default: 'workSchedules:apiErrors.memberSaveDefault',
  },
  DELETE: {
    'WorkSchedule.MemberNotFound': 'workSchedules:apiErrors.memberNotFound',
    default: 'workSchedules:apiErrors.memberDeleteDefault',
  },
};
